function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-arrow-down",
  "data-name": "Icon awesome-arrow-down",
  d: "M29.046,15.645l1.561,1.561a1.681,1.681,0,0,1,0,2.384L16.945,33.258a1.681,1.681,0,0,1-2.384,0L.893,19.589a1.681,1.681,0,0,1,0-2.384l1.561-1.561a1.689,1.689,0,0,1,2.412.028l8.072,8.473V3.938A1.683,1.683,0,0,1,14.625,2.25h2.25a1.683,1.683,0,0,1,1.688,1.688V24.145l8.072-8.473a1.677,1.677,0,0,1,2.412-.028Z",
  transform: "translate(-0.397 -2.25)"
});

function SvgIconawesomeArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.705,
    height: 31.504,
    viewBox: "0 0 30.705 31.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeArrowDown);
export default __webpack_public_path__ + "static/media/Icon awesome-arrow-down.4d4d4fcd.svg";
export { ForwardRef as ReactComponent };